module.exports = __webpack_public_path__ + "img/banner-1.fd0d5e44.jpg";